var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7332 1.82085L20.9902 18.7943C20.7077 19.9921 19.9713 20.2903 18.9248 19.726L13.4215 15.6849L10.6697 18.2299C10.3653 18.5228 10.1105 18.7676 9.52355 18.7676L9.93326 13.1825L20.3035 3.99839C20.7631 3.60446 20.204 3.38613 19.5893 3.78012L6.52179 11.6918L0.896094 9.99874C-0.327604 9.63135 -0.349712 8.82205 1.15077 8.25775L23.1552 0.106511C24.1739 -0.260829 25.0654 0.324739 24.7332 1.82085Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tg-icon.1db3627dbeba60d4d31db851b243441a.svg";
export { ForwardRef as ReactComponent };